export const LOGO = {
  pc: {
    header: '/images/pc/header/logo.png',
  },
  mo: {
    header: '/images/mobile/header/logo.png',
    back: '/images/mobile/header/header-back.svg',
  },
};
export const NAV = {
  pc: {
    logo: LOGO.pc.header,
    globe: '/images/pc/header/globe.svg',
    notice: '/images/pc/header/notification.svg',
    noticeAllRead: '/images/pc/header/notice-read.svg',
  },
  mo: {
    logo: LOGO.mo.header,
    notice: '/images/mobile/header/notice.svg',
  },

};

export const FOOTER = {
  logo: '/images/pc/footer/footer.png',
};

export const MANAGE = {
  pc: {},
  mo: {
    goLeft: '/images/mobile/management/go-left.svg',
    goRight: '/images/mobile/management/go-right.svg',
    deleteLine: '/images/mobile/management/delete-line.svg',
  },
};

export const MODAL = {
  pc: {
    close: '/images/pc/common/modal-close.svg',
    alertClose: '/images/pc/common/alert-close.svg',
  },
  mo: {
    fullPageClose: '/images/mobile/common/page-close.svg',
    optionChecked: '/images/mobile/common/option-checked.svg',
    optionDrop: '/images/mobile/common/option-drop-down.svg',
    agreementPrev: '/images/mobile/common/agreement-prev.svg',
    langClose: '/images/mobile/common/lang-close.svg',
    langChecked: '/images/mobile/common/lang-checked.svg',
    backClose: '/images/mobile/common/chart-back.svg',
    footerTooltipClose: '/images/mobile/common/footer-tooltip-close.svg',
  },
};

export const BOTS = {
  pc: {
    tabBack: '/images/pc/trade/tab-back.svg',
    setting: '/images/pc/trade/setting.svg',
  },
  mo: {
    coinDelete: '/images/mobile/bots/coin-delete.svg',
    coinSearch: '/images/mobile/bots/coin-search.svg',
    hedgeArrow: '/images/mobile/bots/hedge-arrow.svg',
    candle: '/images/mobile/bots/candle-stick.svg',
    removeLine: '/images/mobile/bots/remove.svg',
    appendLine: '/images/mobile/bots/append.svg',
    checked: '/images/mobile/bots/checked.svg',
    calculator: '/images/mobile/bots/calculator.svg',
  },
};

export const PROFIT = {
  pc: {
    link: '/images/pc/trade/profit-link.svg',
    next: {
      month: '/images/pc/profit/next_month.svg',
      year: '/images/pc/profit/next_year.svg',
    },
    prev: {
      month: '/images/pc/profit/prev_month.svg',
      year: '/images/pc/profit/prev_year.svg',
    }
  },
  mo: {
    calendar: '/images/mobile/profit/profit-calendar.svg',
    closeCalendar: '/images/mobile/profit/calender_close.svg',
  }
}

// ========== [ 모바일 ] ============
export const MENU = {
  home: '/images/mobile/nav/home.svg',
  market: '/images/mobile/nav/market.svg',
  bot: '/images/mobile/nav/bot.svg',
  management: '/images/mobile/nav/management.svg',
  info: '/images/mobile/nav/info.svg',
};

export const SIGN = {
  email: '/images/mobile/sign/email.svg',
  pwd: '/images/mobile/sign/pwd.svg',
  otp: '/images/mobile/sign/otp.svg',
  sms: '/images/mobile/sign/sms.svg',
  phone: '/images/mobile/sign/phone.svg',
  on: '/images/mobile/sign/pwd-on.svg',
  off: '/images/mobile/sign/pwd-off.svg',
};

export const PROFILE = {
  lang: '/images/mobile/profile/language.svg',
  langBtn: '/images/mobile/profile/langBtn.svg',
  link: '/images/mobile/profile/link.svg',
  terms: '/images/mobile/profile/terms.svg',
  guide: '/images/mobile/profile/guide.svg',
  business: '/images/mobile/profile/business.svg',
  profit: '/images/mobile/profile/profit.svg',
  data: '/images/mobile/profile/data.svg',
  user: '/images/mobile/profile/user.svg',
  logout: '/images/mobile/profile/logout.svg',
};

export const DATA_STATUS = {
  pc: {},
  mo: {
    nodata: '/images/mobile/common/nodata.svg',
    login: '/images/mobile/common/plzlogin.svg',
  },
};

export const NOTICE = {
  pc: {},
  mo: {
    back: "/images/mobile/notice/notice-back.svg",
    delete: "/images/mobile/notice/notice-delete.svg",
    read: "/images/mobile/notice/notice-read.svg",
    check: "/images/mobile/notice/notice-check.svg",
    allView: "/images/mobile/notice/notice-all-view.svg",
  }
}

export const HOME = {
  pc: {},
  mo: {
    search: '/images/mobile/main/home-search.svg',
    sortUp: '/images/mobile/main/ticker_up.svg',
    sortDown: '/images/mobile/main/ticker_down.svg',
    slide1: '/images/mobile/main/slide1.svg',
    slide2: '/images/mobile/main/slide2.svg',
    slide3: '/images/mobile/main/slide3.svg',
    link: '/images/mobile/main/link.svg',
    guide1: '/images/mobile/main/guide1.svg',
    guide2: '/images/mobile/main/guide2.svg',
    guide3: '/images/mobile/main/guide3.svg',
    guide4: '/images/mobile/main/guide4.svg',
  }
}

export const ERROR = {
  notFound: '/images/pc/common/error.svg',
  refresh: '/images/pc/common/refresh.svg',
}

export const PC_MAIN = {
  firstIcon: "/images/pc/main/main-mobile.svg",
  secondIcon: "/images/pc/main/main-pc.png",
  secondIcon2: "/images/pc/main/main-pc2.png",
  forth1: '/images/pc/main/fourth1.svg',
  forth2: '/images/pc/main/fourth2.svg',
  forth3: '/images/pc/main/fourth3.svg',
  faqArrow: '/images/pc/main/faq-arrow.svg',
  slideArrow: '/images/pc/main/slide-arrow.svg',
}

export const AGREEMENT = {
  checked: "/images/mobile/agreement/agree-checked.png",
  close: "/images/mobile/agreement/agreement-close-button.svg",
  termsIcon: "/images/mobile/agreement/terms-icon.png"
}

/* ] ============= 메세지 =============== [ */
//1. 로그인 에러메세지
// 에러 메시지 상수
export const SIGN_ERROR = {
  RECAPTCHA: '로봇 인증을 완료해주세요.',
  EMAIL_EMPTY: '이메일을 입력해주세요.',
  PHONE_EMPTY: '전화번호를 입력해주세요.',
  EMAIL_INVALID: '이메일 형식이 올바르지 않습니다.',
  PASSWORD_EMPTY: '비밀번호를 입력해주세요.',
  PASSWORD_INVALID: '비밀번호는 최소 4자리~20자리입니다.',
  PASSWORD_FORMAT: '비밀번호 형식이 올바르지 않습니다.',
  SERVER_EMAIL_INVALID: '이메일 형식에 맞게 입력해주세요.',
  SERVER_PASSWORD_INVALID: '비밀번호가 올바르지 않습니다.',
};

/* ] ========== 옵션값 ========= [ */
export const OPTIONS = {
  //모의 계산기
  calculator: {
    //레버리지
    leverage: [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' },
      { value: '13', label: '13' },
      { value: '14', label: '14' },
      { value: '15', label: '15' },
      { value: '16', label: '16' },
      { value: '17', label: '17' },
      { value: '18', label: '18' },
      { value: '19', label: '19' },
      { value: '20', label: '20' },
      { value: '21', label: '21' },
      { value: '22', label: '22' },
      { value: '23', label: '23' },
      { value: '24', label: '24' },
      { value: '25', label: '25' },
      { value: '26', label: '26' },
      { value: '27', label: '27' },
      { value: '28', label: '28' },
      { value: '29', label: '29' },
      { value: '30', label: '30' },
      { value: '31', label: '31' },
      { value: '32', label: '32' },
      { value: '33', label: '33' },
      { value: '34', label: '34' },
      { value: '35', label: '35' },
      { value: '36', label: '36' },
      { value: '37', label: '37' },
      { value: '38', label: '38' },
      { value: '39', label: '39' },
      { value: '40', label: '40' },
      { value: '41', label: '41' },
      { value: '42', label: '42' },
      { value: '43', label: '43' },
      { value: '44', label: '44' },
      { value: '45', label: '45' },
      { value: '46', label: '46' },
      { value: '47', label: '47' },
      { value: '48', label: '48' },
      { value: '49', label: '49' },
      { value: '50', label: '50' },
      { value: '51', label: '51' },
      { value: '52', label: '52' },
      { value: '53', label: '53' },
      { value: '54', label: '54' },
      { value: '55', label: '55' },
      { value: '56', label: '56' },
      { value: '57', label: '57' },
      { value: '58', label: '58' },
      { value: '59', label: '59' },
      { value: '60', label: '60' },
      { value: '61', label: '61' },
      { value: '62', label: '62' },
      { value: '63', label: '63' },
      { value: '64', label: '64' },
      { value: '65', label: '65' },
      { value: '66', label: '66' },
      { value: '67', label: '67' },
      { value: '68', label: '68' },
      { value: '69', label: '69' },
      { value: '70', label: '70' },
      { value: '71', label: '71' },
      { value: '72', label: '72' },
      { value: '73', label: '73' },
      { value: '74', label: '74' },
      { value: '75', label: '75' },
      { value: '76', label: '76' },
      { value: '77', label: '77' },
      { value: '78', label: '78' },
      { value: '79', label: '79' },
      { value: '80', label: '80' },
      { value: '81', label: '81' },
      { value: '82', label: '82' },
      { value: '83', label: '83' },
      { value: '84', label: '84' },
      { value: '85', label: '85' },
      { value: '86', label: '86' },
      { value: '87', label: '87' },
      { value: '88', label: '88' },
      { value: '89', label: '89' },
      { value: '90', label: '90' },
      { value: '91', label: '91' },
      { value: '92', label: '92' },
      { value: '93', label: '93' },
      { value: '94', label: '94' },
      { value: '95', label: '95' },
      { value: '96', label: '96' },
      { value: '97', label: '97' },
      { value: '98', label: '98' },
      { value: '99', label: '99' },
      { value: '100', label: '100' },
      { value: '101', label: '101' },
      { value: '102', label: '102' },
      { value: '103', label: '103' },
      { value: '104', label: '104' },
      { value: '105', label: '105' },
      { value: '106', label: '106' },
      { value: '107', label: '107' },
      { value: '108', label: '108' },
      { value: '109', label: '109' },
      { value: '110', label: '110' },
      { value: '111', label: '111' },
      { value: '112', label: '112' },
      { value: '113', label: '113' },
      { value: '114', label: '114' },
      { value: '115', label: '115' },
      { value: '116', label: '116' },
      { value: '117', label: '117' },
      { value: '118', label: '118' },
      { value: '119', label: '119' },
      { value: '120', label: '120' },
      { value: '121', label: '121' },
      { value: '122', label: '122' },
      { value: '123', label: '123' },
      { value: '124', label: '124' },
      { value: '125', label: '125' },
    ],
    //진입횟수
    cnt_entry: [
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' },
      { value: '13', label: '13' },
      { value: '14', label: '14' },
      { value: '15', label: '15' },
      { value: '16', label: '16' },
      { value: '17', label: '17' },
      { value: '18', label: '18' },
      { value: '19', label: '19' },
      { value: '20', label: '20' },
    ],
    //추가 진입 배율
    rate_extra_entry: [
      { value: '1', label: '1' },
      { value: '1.1', label: '1.1' },
      { value: '1.2', label: '1.2' },
      { value: '1.3', label: '1.3' },
      { value: '1.4', label: '1.4' },
      { value: '1.5', label: '1.5' },
      { value: '1.6', label: '1.6' },
      { value: '1.7', label: '1.7' },
      { value: '1.8', label: '1.8' },
      { value: '1.9', label: '1.9' },
      { value: '2', label: '2' },
      { value: '2.1', label: '2.1' },
      { value: '2.2', label: '2.2' },
      { value: '2.3', label: '2.3' },
      { value: '2.4', label: '2.4' },
      { value: '2.5', label: '2.5' },
      { value: '2.6', label: '2.6' },
      { value: '2.7', label: '2.7' },
      { value: '2.8', label: '2.8' },
      { value: '2.9', label: '2.9' },
      { value: '3', label: '3' },
    ],
    //금액기준 - 최초 투자 증거금 , 총 투자 증거금
    marginStandard: [
      { value: '0', label: '최초 투자 증거금' },
      { value: '1', label: '총 투자 증거금' },
    ],
  },

  //required Wrap
  required: {
    marginMode: [
      { value: 'ISOLATED', label: '격리' },
      { value: 'CROSS', label: '교차' },
    ],
    tpEntryInitial: [
      { value: 'MARKET', label: '시장가' },
      { value: 'LIMIT', label: '지정가' },
    ],
    tpEntryAdditional: [
      { value: 'MARKET', label: '시장가' },
      { value: 'LIMIT', label: '지정비율' },
    ]
  },
};
//온갖 문구
export const WORDS = {
  //상세설정
  detailed: {
    length: "진입 횟수는 최소 2회차까지 설정을 해주셔야합니다."
  },
  //거래하기
  trade: {
    noPosition: "포지션이 존재하지 않습니다.",
    noUnfilled: "미체결 내역이 존재하지 않습니다.",
    noFilled: "체결 내역이 존재하지 않습니다.",
    noBots: "동작중인 봇 내역이 존재하지 않습니다.",
    noTemporary: "임시저장 목록이 존재하지 않습니다.",
  },
  //손익
  profit: {
    currentData: "손익 정보가 존재하지 않습니다."
  }
}

// 언어 옵션
export const LANGUAGE_OPTIONS = [
  { label: '한국어', value: 'KR' },
  { label: 'English', value: 'EN' },
  { label: '日本語', value: 'JP' },
  { label: 'Tiếng Việt', value: 'VI' },
];
